import { useToastServiceStore } from './service-store/service-store';
import { checkEqual } from 'common/helpers/checkEqual';
export var useToastActions = function () {
    return useToastServiceStore(function (state) { return ({
        addToast: state.addToast,
        addErrorToast: state.addErrorToast,
        addSuccessToast: state.addSuccessToast,
        removeToast: state.removeToast,
    }); }, checkEqual);
};
